<template>
  <div class="updateVector newModelPosition hierarchy2">
    <MapModal
      :modalNode="modalNode"
      title="更新数据"
      id="shpModel"
      :close="closeUpdateVector"
      ref="mapModal"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="100px"
        >
          <el-form-item label="新文件" prop="newFile">
            <el-input v-model="form.newFile" class="formName"></el-input>
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="form.newFile"
              :on-change="uploadChange"
              :auto-upload="false"
              :show-file-list="false"
            >
              <el-button slot="trigger" size="mini" type="primary"
                >选取文件</el-button
              >
            </el-upload>
          </el-form-item>
          <el-form-item label="重命名" prop="reName">
            <el-input v-model="form.reName" class="formName"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template slot="foot">
        <div class="foot-operate">
          <span
            >最近更新时间：{{
              updateType.value === "KmlInfo"
                ? updateType.kmlInfo.updatedTime
                : updateType.shpInfo.updatedTime
            }}</span
          >
          <el-button @click="closeUpdateVector"> 取消 </el-button>
          <el-button type="primary" @click="onSubmit('form')"> 确定 </el-button>
        </div>
      </template>
    </MapModal>
  </div>
</template>

<script>
import axios from "axios";
const MapModal = () => import("@/components/common/mapModal/Index");
import { updateKmlInfo, updateShpInfo } from "@/api/api";
export default {
  name: "updateVector",
  components: {
    MapModal,
  },
  props: ["closeUpdateVector", "updateType"],
  data() {
    return {
      modalNode: {
        shp: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -818,
          //   // unit: "px", // 默认px
          // },
          width: "330px", // 宽度配置 默认450px
          height: `160px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      fileList: [],
      rules: {
        newFile: [{ required: true, message: "请上传新文件", trigger: "blur" }],
      },
      form: {
        newFile: "",
        reName: null,
      },
    };
  },
  mounted() {
    this.form.reName = this.updateType.title;
  },
  methods: {
    // 文件改变时
    uploadChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      let name = fileList[0].name;
      const index = name.lastIndexOf(".");
      const res = name.substring(index + 1, name.length);
      if (
        (this.updateType.value == "KmlInfo" && res == "kml") ||
        (this.updateType.value == "ShpInfo" && res == "json")
      ) {
        this.form.newFile = name;
        this.fileList = fileList;
      } else {
        this.form.newFile = null;
        this.fileList = [];
        this.$notify({
          title: "请上传对应类型文件",
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
      }
    },
    // 提交
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            return this.$notify({
              title: "请上传文件",
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
          }
          // 请求
          const formData = new FormData();
          formData.append("files", this.fileList[0].raw); //上传的文件
          if (this.updateType.value === "KmlInfo") {
            this.updateType.kmlInfo.kmlName = this.form.reName;
            for (let key in this.updateType.kmlInfo) {
              formData.append(key, this.updateType.kmlInfo[key]);
            }
            axios
              .post("/baseIP/KmlInfo/editFile", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization:
                    "Bearer " + window.sessionStorage.getItem("token"),
                  "X-Authorization":
                    "Bearer " + window.sessionStorage.getItem("refreshToken"),
                },
              })
              .then((res) => {
                if (res.data.code == 200 || res.data.code == 204) {
                  this.$notify({
                    title: "更新成功",
                    message: "",
                    type: "success",
                    duration: 960,
                    offset: 320,
                  });
                  this.$emit("closeCurrentData", this.updateType);
                  this.$emit("updateSuccess");
                  this.closeUpdateVector();
                }
              });
          }
          if (this.updateType.value === "ShpInfo") {
            this.updateType.shpInfo.shpName = this.form.reName;
            for (let key in this.updateType.shpInfo) {
              formData.append(key, this.updateType.shpInfo[key]);
            }
            axios
              .post("/baseIP/ShpInfo/editFile", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization:
                    "Bearer " + window.sessionStorage.getItem("token"),
                  "X-Authorization":
                    "Bearer " + window.sessionStorage.getItem("refreshToken"),
                },
              })
              .then((res) => {
                if (res.data.code == 200 || res.data.code == 204) {
                  this.$notify({
                    title: "更新成功",
                    message: "",
                    type: "success",
                    duration: 960,
                    offset: 320,
                  });
                  this.$emit("closeCurrentData", this.updateType);
                  this.$emit("updateSuccess");
                  this.closeUpdateVector();
                }
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/box.scss";
.updateVector {
  /deep/.el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding: 8px 0 14px 0;
    margin-left: -23px;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
          width: auto !important;
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 166px;
          @include button_primary();
          @include button_default();
        }
      }
    }
    @include switch_base();
    .el-switch {
      width: 45px;
      margin: 0;
      .el-switch__label {
        width: 28px;
        span {
          width: 28px;
          font-size: 11px;
        }
        &.el-switch__label--left {
          margin-right: 5px;
        }
        &.el-switch__label--right {
          margin-left: 5px;
        }
      }
      .el-switch__core {
        width: 40px !important;
        @include lheight(20);
        margin: 0 5px;
      }
    }
  }
}
/deep/.formName {
  width: auto !important;
  margin-right: 15px;
  .el-input__inner {
    width: 130px !important;
  }
}
.foot-operate {
  padding: 10px 5px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px !important;
    font-size: 12px;
    padding: 2px 10px;
    line-height: inherit;
    height: auto;
  }
  span {
    color: #c0c4cc;
    font-size: 12px;
    // padding-right: 41px;
  }
}
</style>
